import { render, staticRenderFns } from "./subjects.vue?vue&type=template&id=63b93642&"
import script from "./subjects.ts?vue&type=script&lang=ts&"
export * from "./subjects.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports